const features = [
  {
    icon: 'ri-leaf-line',
    title: '天然精華配方',
    description: '精選人參、枸杞、淫羊藿等天然草本，科學配比，溫和有效。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全品質保證',
    description: '通過多重品質檢測，不添加人工色素與防腐劑，使用更安心。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '快速感受活力',
    description: '持續使用2-4週，多數用戶即可感受到活力與自信的明顯提升。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '全面身心調理',
    description: '不僅提升身體活力，更有助於改善整體精神狀態與生活品質。',
  },
  {
    icon: 'ri-user-star-line',
    title: '專業團隊研發',
    description: '由資深草本研究團隊歷經十年研發，融合傳統智慧與現代科技。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '貼心售後服務',
    description: '提供專業健康顧問一對一諮詢，全程為您的健康保駕護航。',
  },
];

function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            為什麼選擇性福寶？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            多年科研積累與用戶口碑，讓性福寶成為值得信賴的活力之選
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-100/70 rounded-lg p-6 md:p-7 hover:bg-background-100 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;